'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$19$$anon$29(evaluator$32) {
  this.Ly = null;
  this.Ly = evaluator$32;
}
export { $c_Lsamples_Persons$package$$anon$19$$anon$29 as $c_Lsamples_Persons$package$$anon$19$$anon$29 };
$p = $c_Lsamples_Persons$package$$anon$19$$anon$29.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$19$$anon$29;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$19$$anon$29() {
}
export { $h_Lsamples_Persons$package$$anon$19$$anon$29 as $h_Lsamples_Persons$package$$anon$19$$anon$29 };
$h_Lsamples_Persons$package$$anon$19$$anon$29.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.Ly.h();
  return (((typeof v) === "number") ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Persons$package$$anon$19$$anon$29 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$19$$anon$29, "samples.Persons$package$$anon$19$$anon$29", ({
  pJ: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$19$$anon$29 as $d_Lsamples_Persons$package$$anon$19$$anon$29 };
